import { useState } from 'react';
import { Trash2 } from 'lucide-react';
import Card from '@/components/ui/Card';
import DeleteAccountModal from './DeleteAccountModal';

export default function DeleteAccountCard() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Card>
        <button
          type="button"
          onClick={() => setOpen(true)}
          className="flex items-center gap-3 w-full cursor-pointer"
        >
          <Trash2 size={20} className="text-error" />
          <span className="font-sans font-medium text-base text-error">
            Delete account
          </span>
        </button>
      </Card>
      <DeleteAccountModal visible={open} onClose={() => setOpen(false)} />
    </>
  );
}
